import { call, put, takeEvery } from "redux-saga/effects";
import { chuongTrinhDaoTaoKienThucApi } from "../../../api/category/chuongTrinhDaoTaoKienThucApi";
import { rootActions } from "../../actions/rootActions";
import { eChuongTrinhDaoTaoKienThucIds } from "../../action-types/chuong-trinh-dao-tao/IChuongTrinhDaoTaoKienThucActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";

export function* chuongTrinhDaoTaoKienThucSaga(): any {
  yield takeEvery(eChuongTrinhDaoTaoKienThucIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseResponse = yield call(chuongTrinhDaoTaoKienThucApi.SelectAll);
  if (res.is_success) {
    yield put(
      rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTaoKienThuc.LOAD_SUCCESS(toLowerCaseDeep(res.data))
    );
  } else {
    yield put(
      rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTaoKienThuc.LOAD_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
